<!--
  The planned hours of a robot over the last 3 days, against its runs.

  A stopped cron writes no row: the empty hour is the only trace it leaves, so
  every planned hour is drawn, run or not. Two forms:
    - compact (tiles): one mark per hour, grouped by day, and the count in words;
    - full (detail): one line per day, each hour with its time and its word.
  Never the colour alone: the marks differ by shape too (filled = it ran,
  hollow = it did not start), every mark has its words in a tooltip, and the
  count next to the strip says the same thing in words.
-->
<template>
  <div v-if="mode === 'compact'" class="ds-strip">
    <div class="ds-strip-days">
      <span v-for="d in days" :key="d.key" class="ds-strip-day" :title="d.label">
        <span v-for="s in d.slots" :key="String(s.at)" class="ds-mark" :class="`is-${s.status}`"
              :title="`${d.label} ${roTime(s.at)} · ${runLabel(s.status)}${s.error ? ' · ' + s.error : ''}`" />
      </span>
    </div>
    <span class="ds-strip-sum" :class="{ 'is-bad': summary.bad }">{{ summary.text }}</span>
  </div>

  <div v-else class="ds-strip-full">
    <div v-if="!days.length" class="hv2-muted">No planned hour in the last 3 days.</div>
    <div v-for="d in days" :key="d.key" class="ds-strip-row">
      <div class="ds-strip-rowday">{{ d.label }}</div>
      <div class="ds-strip-rowslots">
        <span v-for="s in d.slots" :key="String(s.at)" class="ds-strip-slot" :title="s.error || ''">
          <span class="ds-mark" :class="`is-${s.status}`" />
          <span class="ds-strip-time">{{ roTime(s.at) }}</span>
          <span class="ds-strip-word" :class="`is-${runTone(s.status)}`">{{ runLabel(s.status) }}</span>
        </span>
      </div>
    </div>
    <div class="ds-strip-legend hv2-muted">
      <span><span class="ds-mark is-ok" /> good</span>
      <span><span class="ds-mark is-partial" /> incomplete</span>
      <span><span class="ds-mark is-failed" /> failed</span>
      <span><span class="ds-mark is-missed" /> did not start</span>
      <span><span class="ds-mark is-running" /> waiting</span>
      <span><span class="ds-mark is-paused" /> paused</span>
    </div>
  </div>
</template>

<script>
import { roDayKey, roDayWord, roTime } from '@/helpers/romaniaTime'
import { runLabel, runTone, slotsSummary } from '../services'

export default {
  name: 'SlotStrip',
  props: {
    slots: { type: Array, default: () => [] },
    mode: { type: String, default: 'compact' }   // compact | full
  },
  computed: {
    days () {
      const out = []
      for (const s of this.slots || []) {
        const key = roDayKey(s.at)
        let d = out.find((x) => x.key === key)
        if (!d) {
          const word = roDayWord(s.at)
          d = { key, label: word.charAt(0).toUpperCase() + word.slice(1), slots: [] }
          out.push(d)
        }
        d.slots.push(s)
      }
      return this.mode === 'full' ? out.slice().reverse() : out
    },
    summary () { return slotsSummary(this.slots) }
  },
  methods: { roTime, runLabel, runTone }
}
</script>
